var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18.5,
    width: 18,
    height: 18,
    transform: "rotate(-180 18 18.5)",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2583_6907",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2583_6907",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAABTUlEQVR4nO3XQWrDMBRF0T/NJkLozjrroltCF9KqFKxh04Gd5Ek6BzQyNsIX2VIVAAAAAAAAAAAAEO+yDQKcq+qjqj6r6uXZk1ndeYvRtiFKUIwmSl6MJkpejCZKXowmSl6MJsr9XKrqeuOlf23jr+u/9zqnPGhlfFfVW1W9/hPFlviBMTpRgmJ0ogTF6EQJitGJEhSjEyUoRidKUIxOlKAYnShBMTpRgmJ0ogTF6EQJitGJEhSjWzpKWoylo6TGWDJKeoyloowSY4koo8WYOsqoMaaMMnqMqaLMEmOKKLPFGDrKrDGGjDJ7jKGirBJjiCirxYiOsmqMyCirx4iKIkZQFDGCoogRFEWMoChiBEURIyiKGGFRbgVZ5ZxxzyiHrRIx9kc57D8ixv4oh+203n2mdke5HnkWOR31oIWdnj0BAAAAAAAAAAAAqGf7ASnrxLXh7bdVAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.87cfb2322c8e0924b0dfc56287cc382d.svg";
export { ForwardRef as ReactComponent };